import React, { Fragment } from 'react'
import estilos from './Documentacion.module.css'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import BotonVerArchivosComponent from './BotonesComponent/BotonVerArchivosComponent';
import BotonHistorialComponent from './BotonesComponent/BotonHistorialComponent';
import BotonSustituirComponent from './BotonesComponent/BotonSustituirComponent';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import BotonVerOficioComponent from './BotonesComponent/BotonVerOficiosComponent';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import { obtenerTodoHistorialCliente } from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import BotonGenerarOficiosComponent from './BotonesComponent/BotonGenerarOficiosComponent';
function OficiosComponent(props) {
    let detalleCliente = props?.detalle
    const dispatch = useDispatch()

    let rowsDocumentacionOficios = []
    function sortJSON(data, key, orden) {
        const copiedData = [...data];
        return copiedData.sort(function (a, b) {
            var x = a[key],
                y = b[key];
            if (orden === 'asc') {
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            }
            if (orden === 'desc') {
                return ((x > y) ? -1 : ((x < y) ? 1 : 0));
            }
        });
    }
    const OficiosDesc = sortJSON(detalleCliente.oficioscliente, 'idoficioscliente', 'desc')
    for (const i in OficiosDesc) {
        let nombre = ''
        if (OficiosDesc?.[i]?.idoficio == 1) nombre = 'Asignación de número de cliente'
        if (OficiosDesc?.[i]?.idoficio == 2) nombre = 'Contrato de prestación de servicios'
        if (OficiosDesc?.[i]?.idoficio == 3) nombre = 'Contraseña oficial NOM'
        //if (OficiosDesc?.[i]?.idoficio == 3 && rowsDocumentacionOficios?.filter(oficio => oficio.nameDoc == 'Contraseña oficial NOM')?.length == 0) {
        rowsDocumentacionOficios.push({
            id: uuidv4(),
            tabla: 'oficioscliente',
            nombreId: 'idoficioscliente',
            nameDoc: nombre,
            idAnexo: OficiosDesc?.[i]?.idoficioscliente,
            idSolicitud: OficiosDesc?.[i]?.idoficioscliente,
        })
        //}
        /*if (OficiosDesc?.[i]?.idoficio == 2 && rowsDocumentacionOficios?.filter(oficio => oficio.nameDoc == 'Contrato de prestación de servicios')?.length == 0) {
            rowsDocumentacionOficios.push({
                id: uuidv4(),
                tabla: 'oficioscliente',
                nombreId: 'idoficioscliente',
                nameDoc: nombre,
                idAnexo: OficiosDesc?.[i]?.idoficioscliente,
                idSolicitud: OficiosDesc?.[i]?.idoficioscliente,
            })
        }
        if (OficiosDesc?.[i]?.idoficio == 1 && rowsDocumentacionOficios?.filter(oficio => oficio.nameDoc == 'Asignación de número de cliente')?.length == 0) {
            rowsDocumentacionOficios.push({
                id: uuidv4(),
                tabla: 'oficioscliente',
                nombreId: 'idoficioscliente',
                nameDoc: nombre,
                idAnexo: OficiosDesc?.[i]?.idoficioscliente,
                idSolicitud: OficiosDesc?.[i]?.idoficioscliente,
            })
        }*/

    }
    const columnsDocumentacion = [
        {
            field: 'nameDoc', headerName: '', headerAlign: 'center', width: 660, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla ?
                            <div style={{ width: '100%', textAlign: 'left' }}>
                                <label>{`${params.row.nameDoc}`}</label>
                            </div>
                            :
                            <div style={{ width: '100%', padding: '3%' }}>
                                <label className={`${estilos.divisionDocumentacion}`}>{`${params.row.nameDoc}`}</label>
                            </div>
                    }
                </Fragment>
            )
        },
        {
            field: 'archivo', headerName: '', headerAlign: 'center', width: 160, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <Fragment>
                            <BotonVerOficioComponent tabla={params.row?.tabla} nombreId={params.row?.nombreId} idSolicitud={params.row?.idSolicitud} />
                            <Tooltip title="Ver historial de cambios"><IconButton size="large" onClick={() => { handleModalHistorial(params) }}> <HistoryRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                </Fragment>
            )
        },
    ]

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState([]);
    const [archivo, setArchivo] = React.useState('');

    const handleModalHistorial = async (params) => {
        let data = { idSolicitud: params.row.idAnexo, tabla: params.row.tabla }
        let datosObtenidos = await dispatch(obtenerTodoHistorialCliente(data))
        setDataHistorial(datosObtenidos?.payload)
        setArchivo(params?.row?.nameDoc)
        setOpenModalHistorial(true)
    }

    const [openModalSustituir, setOpenModalSustituir] = React.useState(false);
    const [dataSustituir, setDataSustituir] = React.useState([]);

    const sustituir = async (params) => {
        setDataSustituir(params.row)
        setOpenModalSustituir(true)
    }
    const [openModalGenerarOficio, setOpenModalGenerarOficio] = React.useState(false);
    const [dataGenerarOficio, setDataGenerarOficio] = React.useState([]);

    const GenerarOficio = async (params) => {
        setDataGenerarOficio(params.row)
        setOpenModalGenerarOficio(true)
    }
    return (
        <Fragment>
            <div style={{ fontFamily: 'Montserrat', height: '700px' }}>
                <h5 style={{ textAlign: 'center', fontWeight: 'bold', color: '#7D9A47' }} >Oficios.</h5>
                <Box sx={{ height: '700px', width: '100%', mt: 2 }}>
                    <DataGrid
                        rows={rowsDocumentacionOficios}
                        columns={columnsDocumentacion}
                        rowsPerPageOptions={[50]}
                        headerHeight={0}
                        getRowHeight={() => 'auto'}
                        sx={{
                            boxShadow: 0,
                            color: 'black',
                            border: 0,
                            backgroundColor: 'white',
                            fontFamily: 'Montserrat',
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#4399A4',
                                color: 'white',
                                fontFamily: 'Montserrat',
                                fontWeight: 'bold',
                                height: '5px'
                            }
                        }}
                    />
                </Box>
            </div>
            {openModalHistorial && <BotonHistorialComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} archivo={archivo} />}
            {openModalSustituir && <BotonSustituirComponent setOpenModalSustituir={setOpenModalSustituir} data={dataSustituir} idcliente={detalleCliente?.idcliente} />}
            {openModalGenerarOficio && <BotonGenerarOficiosComponent setOpenModalGenerarOficio={setOpenModalGenerarOficio} data={dataGenerarOficio} idcliente={detalleCliente?.idcliente} />}
        </Fragment>
    )

}

export default OficiosComponent